import { useState } from 'react';
import { Error } from 'src/components/Banners';
import AgreementsTable from 'src/components/Agreements/AgreementsTable';
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import tableStyles from 'styles/table.module.css';

export default function Agreements({ agreements }) {
  const [error] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isLoading = agreements === null || agreements === undefined;
  const isLoaded = error || agreements;

  return (
    <>
      <div>
        {error && <Error error={error} isLoading={!isLoaded} />}
        {isLoading ? (
          <Paper elevation={1} sx={{ p: isMobile ? '0 0 25px 0' : '10px 30px 30px 30px', height: '100%' }}>
            <div className={tableStyles.motusTableWrap}>
              <AgreementsTable agreements={[]} isLoading={true} showClaimIds showLinkToAgreement />
            </div>
          </Paper>
        ) : (
          agreements &&
          (agreements.length === 0 ? (
            <Typography sx={{ fontSize: '24px' }}>Engin virk samkomulög</Typography>
          ) : (
            <Paper elevation={1} sx={{ p: isMobile ? '0 0 25px 0' : '10px 30px 30px 30px', height: '100%' }}>
              <div className={tableStyles.motusTableWrap}>
                <AgreementsTable agreements={agreements} isLoading={false} showClaimIds showLinkToAgreement />
              </div>
            </Paper>
          ))
        )}
      </div>
    </>
  );
}

Agreements.propTypes = {
  agreements: PropTypes.array,
};
